import { UntitledIcon } from '@faceup/icons'
import { usCheckCircle } from '@faceup/icons/usCheckCircle'
import { ChannelType } from '@faceup/utils'
import type { ReactNode } from 'react'
import { useSurveyPreview } from '../../hooks/useSurveyPreview'
import { defineMessages, FormattedMessage } from '../../TypedIntl'
import PageTitle from '../PageTitle'

const messagesPerChannel = defineMessages<ChannelType>({
  [ChannelType.AutomatedHotline]: 'Shared.CompanyReportSent.title',
  [ChannelType.LiveHotline]: 'Shared.CompanyReportSent.title',
  [ChannelType.AiHotline]: 'Shared.CompanyReportSent.title',
  [ChannelType.ReportingSystem]: 'Shared.CompanyReportSent.title',
  [ChannelType.Survey]: 'Shared.surveys.detail.afterSendPageTitle',
})

type SentContentChannelProps = {
  children?: ReactNode
  description?: ReactNode
  sourceType: ChannelType
  title?: never
}

type SentContentTitleProps = {
  children?: ReactNode
  description?: ReactNode
  title: ReactNode
  sourceType?: never
}

type SentContentProps = SentContentChannelProps | SentContentTitleProps

export const SentContent = (props: SentContentProps) => {
  const { children, description } = props
  const { isPreview } = useSurveyPreview()

  const resolvedTitle: ReactNode = (() => {
    if ('title' in props && props.title !== undefined) {
      return props.title
    }
    if (!('sourceType' in props) || !props.sourceType) {
      return null
    }
    return <FormattedMessage {...messagesPerChannel[props.sourceType]} />
  })()

  return (
    <div
      className='flex flex-col items-center gap-6 w-full px-8'
      data-test='ReportSent'
      inert={isPreview || undefined}
    >
      <UntitledIcon icon={usCheckCircle} size={64} className='text-colorPrimary' />
      <PageTitle description={description}>{resolvedTitle}</PageTitle>
      <div className='flex flex-col gap-6 w-full'>{children}</div>
    </div>
  )
}
